import dynamic from "next/dynamic";
import { LucideProps } from "lucide-react";
import dynamicIconImports from "lucide-react/dynamicIconImports";
import { memo } from "react";

interface IconProps extends LucideProps {
    name: keyof typeof dynamicIconImports;
    size?: number;
}

const DynamicIcon = memo(({ name, size = 20, ...props }: IconProps) => {
    const LucideIcon = dynamic(dynamicIconImports[name], {
        loading: () => (
            <div
                style={{
                    width: size,
                    height: size,
                }}
            />
        ),
        ssr: false,
    });

    return <LucideIcon size={size} {...props} />;
});

DynamicIcon.displayName = "DynamicIcon";

export default DynamicIcon;
